import { Fragment } from "react";
import { Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";
import { useSeo } from "../lib/seo";
import { PageShell, Panel } from "../components/PageShell";
import { PopButton } from "../components/PopButton";
import { PAUL } from "../data/infoPages";

const linkCls = "font-extrabold text-[#FF5D1F] underline";

function Rich({ text }: { text: string }) {
  const parts = text.split(/\[([^\]]+)\]\(([^)]+)\)/);
  return <>{parts.map((p, i) => (i % 3 === 1 ? <Link key={i} to={parts[i + 1]} className={linkCls}>{p}</Link> : i % 3 === 2 ? null : <Fragment key={i}>{p}</Fragment>))}</>;
}

const para = "mt-2 text-sm font-semibold leading-relaxed text-[#3b1800] sm:text-base";

export default function MeetPaulPage() {
  useSeo({ title: PAUL.title, description: PAUL.description, path: "/about/paul", jsonLd: { "@context": "https://schema.org", "@type": "Person", name: "Paul", jobTitle: "Founder", worksFor: { "@type": "Organization", name: "Stop Dithering" } } });
  return (
    <PageShell title={PAUL.h1} subtitle={PAUL.subtitle} back="/about" testId="meet-paul-page">
      <Panel className="!p-3 sm:!p-5">
        <div className="flex items-start gap-3 sm:gap-4">
          <span className="flex h-16 w-16 shrink-0 -rotate-6 items-center justify-center rounded-2xl border-[3px] border-[#3b1800] bg-[#FFE14D] font-comic text-4xl text-[#FF5D1F] shadow-[0_4px_0_#3b1800] sm:h-20 sm:w-20 sm:text-5xl" aria-hidden data-testid="paul-badge">P</span>
          <div className="min-w-0 flex-1" data-testid="paul-story">
            {PAUL.paras.map((t) => <p key={t} className={para}><Rich text={t} /></p>)}
          </div>
        </div>
      </Panel>
      <Panel className="mt-2 !p-3 sm:!p-5">
        <h2 className="font-comic text-xl text-[#FF5D1F]">Other projects</h2>
        <p className={para}>{PAUL.projectsIntro}</p>
        <ul className="mt-2 grid gap-2 sm:grid-cols-2" data-testid="paul-projects">
          {PAUL.projects.map((p) => (
            <li key={p.name} className="rounded-xl border-2 border-[#FFD9A8] bg-[#FFF6E6] p-3" data-testid={`paul-project-${p.name.toLowerCase().replace(/\s+/g, "-")}`}>
              <h3 className="font-comic text-base">
                {p.url ? <a href={p.url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-[#3b1800] hover:text-[#FF5D1F] hover:underline">{p.name}<ExternalLink className="h-3.5 w-3.5" strokeWidth={3} /></a> : p.name}
              </h3>
              <p className="mt-0.5 text-sm font-semibold text-[#6b3a12]">{p.text}</p>
            </li>
          ))}
        </ul>
        {PAUL.outro.map((t) => <p key={t} className={para}>{t}</p>)}
      </Panel>
      <div className="mt-3 flex flex-wrap gap-2">
        <Link to="/"><PopButton tone="orange" data-testid="paul-start-button">Start dithering</PopButton></Link>
        <Link to="/contact"><PopButton tone="white" data-testid="paul-contact-button">Say hello</PopButton></Link>
      </div>
    </PageShell>
  );
}
